// export const api = "http://35.244.3.174:4000"

// export const api = "http://localhost:4000"
//export const api = "http://35.244.12.111:4000"
// export const api ='http://13.235.102.214:4000'
// export const api = "https://api.langistan.com";
export const api = 'https://langistanbackend-production.up.railway.app/api'
export const noImageFoundText = "No Image Found"
//export const api ='http://13.235.102.214:4000'
// export const api = 'http://13.235.102.214:4000'
